class RangeInputModel {
    constructor(params, componentInfo) {

        this.#minValue(ko.unwrap(params.minValue));
        this.#maxValue(ko.unwrap(params.maxValue));

        this.#minValue.extend({ notify: 'always' });

        this.minRange = ko.unwrap(params.min);
        this.maxRange = ko.unwrap(params.max);

        this.unit = params.unit;
        this.gap = params.gap || 5;

        this.change = params.change;
    }

    // Behaviors
    #minValue = ko.observable();    #maxValue = ko.observable();
    minValue = ko.pureComputed({
        read: this.#minValue,
        write: value => {
            var newValue = Number.parseInt(value);
            if (newValue == Number.NaN || newValue < this.minRange) {
                newValue = this.minRange;
            } else if (newValue >= this.#maxValue()) {
                newValue = this.#maxValue() - this.gap;
            }

            if (newValue < this.minRange) {
                newValue = this.minRange;
            }

            this.#minValue(newValue);
        }
    });

    maxValue = ko.pureComputed({
        read: this.#maxValue,
        write: value => {
            var newValue = Number.parseInt(value);
            if (newValue == Number.NaN) {
                newValue = this.maxRange;
            } else if (newValue <= this.#minValue()) {
                newValue = this.#minValue() + this.gap;
            }

            if (newValue > this.maxRange) {
                newValue = this.maxRange;
            }

            this.#maxValue(newValue);
        }
    });

    maxActive = ko.pureComputed(() => this.#maxValue() && this.#maxValue() !== this.maxRange);
    minActive = ko.pureComputed(() => this.#minValue() && this.#minValue() !== this.minRange);

    minPercent = ko.pureComputed({
        read: () => Math.floor((this.#minValue() - this.minRange) / (this.maxRange - this.minRange) * 100),
        write: value => {
            let newValue = Number.parseInt(value);
            if (newValue >= this.maxPercent()) {
                newValue = this.maxPercent() - this.gap;
            }

            newValue = this.minRange + Math.floor(newValue * (this.maxRange - this.minRange) / 100);
            if (newValue <= this.minRange) {
                this.#minValue(this.minRange);
            } else
            {
                this.#minValue(newValue);
            }
        }
    });

    maxPercent = ko.pureComputed({
        read: () => Math.ceil((this.#maxValue() - this.minRange) / (this.maxRange - this.minRange) * 100),
        write: value => {
            let newValue = Number.parseInt(value);
            if (newValue <= this.minPercent()) {
                newValue = this.minPercent() + this.gap;
            }

            newValue = this.minRange + Math.ceil(newValue * (this.maxRange - this.minRange) / 100);
            if (newValue >= this.maxRange) {
                this.#maxValue(this.maxRange);
            } else {
                this.#maxValue(newValue);
            }
        }
    })

    minInput = (model, e) => {
        if (e.currentTarget.value >= this.maxPercent() - 5) {
            e.target.value = this.maxPercent() - this.gap;
        }
    }

    maxInput = (model, e) => {
        if (e.currentTarget.value <= this.minPercent() + 5) {
            e.target.value = this.minPercent() + this.gap;
        }
    }

    rangeChanged = (model, e) => {
        this.change({
            min: this.#minValue(),
            max: this.#maxValue()
        });
    }
}

ko.components.register('range-slider', {
    viewModel: {
        createViewModel: (params, componentInfo) => new RangeInputModel(params, componentInfo)
    },
    template: `
       <div class="range-slider">
           <div class="slider-track"></div>
           <div class="slider-track-active" data-bind="style: { left: minPercent() + '%', width: maxPercent() - minPercent() + '%' }"></div>
           <input type="range" class="slider-left form-range" tabindex="0" min="0" max="100" step="1" data-bind="event: { input: minInput, change: rangeChanged }, textInput: minPercent, css: { disabled: !minActive() }">
           <input type="range" class="slider-right form-range" tabindex="0" min="0" max="100" step="1" data-bind="event: { input: maxInput, change: rangeChanged }, textInput: maxPercent, css: { disabled: !maxActive() }">
       </div>
       <div class="input-box">
          <input type="text" class="form-control" placeholder="" data-bind="value: minValue">
          <span> - </span>  
          <input type="text" class="form-control" placeholder="" data-bind="value: maxValue">
       </div>
    `
});